// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"RecruitViewList_modal-scroll__WRTHU","pagination":"RecruitViewList_pagination__Img3k"};